import { LiveLikeVoteCount } from "@livelike/engagementsdk";

class VoteCount extends LiveLikeVoteCount {
  @((window as any).property({ type: Number })) nzrVoteCount: number = 0;

  // The SDK only refreshes owner.count on mount and local votes - polling
  // updates the options but never the total. Recompute from options on every
  // owner event (same trigger the percentage bars use), only ever increasing.
  ownerUpdated = () => {
    const owner = (this as any).owner;
    const opts = owner?.options;
    if (Array.isArray(opts) && opts.length) {
      const total = Math.max(
        opts.reduce(
          (a: number, c: any) => a + (Number(c?.vote_count) || 0),
          0,
        ),
        Number(owner?.count || 0),
      );
      if (total > Number(this.count || 0)) {
        this.count = total as any;
      }
    }
  };
}

customElements.define("sbs-vote-count", VoteCount as any);
